<template>
	<div>
		<toolbar>
			<router-link to="/service-contracts/contracts-list" class="btn btn-link">
				<i class="fa fa-caret-left fa-2x"></i>
				<h2>Service Contracts</h2>
			</router-link>

			<div class="controls">
				<slot name="toolbar-slot"></slot>
				<nav-tabs :tabs="tabs"></nav-tabs>
			</div>

		</toolbar>
	</div>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import NavTabs from "@/layout_fragments/NavTabs"
import Widget from "@/components/Widget"
import VueForm from "@/components/VueForm"

export default {
	name: "ServiceContractToolbar",
	components: {
		Toolbar,
		NavTabs,
		Widget,
		VueForm
	},
	props: ["customerName","hideHeadingWidget"],
	computed: {
		tabs() {
			const sc = this.$store.serviceContract

			let numFiles = ""
			if (sc && sc.ServiceContractFile && sc.ServiceContractFile.length > 0)
				numFiles = " (" + sc.ServiceContractFile.length + ")"

			let tabs = [
				{
					label: "Contract Details",
					icon: "fa-list",
					path: "/service-contract/"+this.$route.params.slug+"/details"
				},
				{
					label: "Personnel",
					icon: "fa-users",
					path: "/service-contract/"+this.$route.params.slug+"/personnel"
				}
			]

			if (sc && sc.contract_type == 'scheduleOfValues')
				tabs.push({
					label: "Schedule of Values",
					icon: "fa-list-ol",
					path: "/service-contract/"+this.$route.params.slug+"/tasks"
				})

			else if (sc && sc.contract_type == "product")
				tabs.push({
					label: "Products",
					icon: "fa-tags",
					path: "/service-contract/"+this.$route.params.slug+"/products"
				})

			tabs = [
				...tabs,
				{
					label: "Materials List",
					icon: "fa-tags",
					path: "/service-contract/"+this.$route.params.slug+"/materials"
				},
				{
					label: "Files"+numFiles,
					icon: "fa-file-image",
					path: "/service-contract/"+this.$route.params.slug+"/files"
				}
			]

			if (this.$route.params.slug == 'new') 
				return [tabs[0]] //only the details page
			
			else 
				return tabs
			
		}
	}

}
</script>